import { createSelector } from '@ngrx/store';

import { IntegrationsFeatureFlagsSelectors } from '@core/integrations-data';
import type { CampaignAnalyticsConfig } from '@core/integrations-legacy';
import { createEntityCollectionStore } from '@core/ngrx-legacy';

const {
  actions,
  namespace,
  selectors: defaultSelectors,
  reducer,
} = createEntityCollectionStore<CampaignAnalyticsConfig>()('CampaignAnalyticsConfig', {
  idSelector: config => config.codename,
  customActions: _adapter => ({}),
});

const normalizeCodename = (codename: string) => codename.replace(/-/g, '_');

const filterInactiveConfigs = (
  campaignAnalyticsConfigs: CampaignAnalyticsConfig[],
  flags: Record<string, boolean>,
): CampaignAnalyticsConfig[] =>
  campaignAnalyticsConfigs.filter(
    analyticItem => !!flags[normalizeCodename(analyticItem.codename)],
  );

const selectors = {
  ...defaultSelectors,
  active: createSelector(
    defaultSelectors.entities(),
    IntegrationsFeatureFlagsSelectors.data,
    filterInactiveConfigs,
  ),
};

export {
  actions as CampaignAnalyticsConfigActions,
  namespace as CampaignAnalyticsConfigNamespace,
  reducer as CampaignAnalyticsConfigReducer,
  selectors as CampaignAnalyticsConfigSelectors,
};
